import { useMemo } from 'react'
import { PROGRESS_STEPS } from '../constants/steps'

export const useFormProgress = formData => {
	return useMemo(() => {
		const hasVal = val => val && val.toString().trim().length > 0

		const isA = hasVal(formData.sectionA.fullName) && hasVal(formData.sectionA.address) ? 1 : 0

		const isB = formData.sectionB.hasInsurance !== null ? 1 : 0

		const isC = formData.sectionC.hasMaintenanceClaims !== null ? 1 : 0

		const isD = formData.sectionD.hasDependents !== null ? 1 : 0

		let isE = 0
		const isSGBXII = formData.sectionE?.receivesSocialAssistanceSGBXII === 'yes'

		if (formData.sectionE?.receivesSocialAssistanceSGBXII) {
			isE = 1
		}

		let isF = isSGBXII ? 1 : 0
		let isG = isSGBXII ? 1 : 0
		let isH = isSGBXII ? 1 : 0
		let isI = isSGBXII ? 1 : 0
		let isJ = isSGBXII ? 1 : 0

		if (!isSGBXII) {
			isF = isE

			isG = formData.sectionG.bankAccounts.has !== null ? 1 : 0

			isH = formData.sectionH.housingType ? 1 : 0

			isI = formData.sectionI.hasObligations !== null ? 1 : 0

			isJ = formData.sectionJ.hasSpecialLoads !== null ? 1 : 0
		}

		let isL = isJ === 1 || isSGBXII ? 1 : 0

		const isReview = formData.sectionK?.date ? 1 : 0

		const isK = formData.sectionK?.date ? 1 : 0

		const totalSteps = 13
		const completedSteps =
			isA + isB + isC + isD + isE + isF + isG + isH + isI + isJ + isL + isReview + isK
		const progressPercent = Math.round((completedSteps / totalSteps) * 100)

		// Evenly spaced along the bar, first entry at 0 and last at 100.
		const milestones = PROGRESS_STEPS.map(({ label }, index) => ({
			label,
			position: Math.round((index / (PROGRESS_STEPS.length - 1)) * 10000) / 100,
		}))

		return {
			globalProgress: progressPercent,
			milestones,
		}
	}, [formData])
}
